import quizManager from '../../managers/QuizManager';

class PointMarkupBuilder {
	getMarkup(pointInfo) {
		if (!quizManager.isRunning() && !quizManager.isFinished()) { 
			return "<h3>Spustite kvíz pomocou tlačidla, potom sa tu zobrazí kvízová ukážka</h3>";
		}

		if (!pointInfo["dialect_id"]) {
			return `Pre toto miesto nemáme dáta`;
		}

		const dialectId = parseInt(pointInfo["dialect_id"]);

		const dialects = JSON.parse(document.getElementById("appContainer").dataset.dialects);
		let dialect = dialects[dialectId];

		let dialectMarkup = '';

		do {
			dialectMarkup = `<strong>${dialect.level_name}:</strong> <a href="" class="link js-show-dialect" data-dialect-id="${dialect.id}">${dialect.level != 'region' ? dialect.code : ''} ${dialect.name}</a><br>` + dialectMarkup;
			dialect = dialects[dialect.parent_id] || null;
		} while (dialect != null);

		let markup = `<div class="popup__info">`;

		if (pointInfo["NAZ_OBEC"]) {
			let name = pointInfo["NAZ_OBEC"];

			if (pointInfo["NAZ_COB"]) {
				name = pointInfo["NAZ_COB"] + ", " + name;
			}

			markup += `
    <h2>${name}</h2>
    <h3>Územie</h3>
`;

			if (pointInfo["NAZ_KRAJ"]) {
				markup += `<strong>Kraj:</strong> ${pointInfo["NAZ_KRAJ"]}<br>`;
			}

/* 			if (pointInfo["NAZ_OKRES"]) {
				markup += `<strong>Okres:</strong> ${pointInfo["NAZ_OKRES"]}`;

				if (pointInfo["ZKR_OKRES"]) {
					markup += ` (${pointInfo["ZKR_OKRES"]})`;
				}

				markup += `<br>`;
			}

			markup += `<strong>Obec:</strong> ${pointInfo["NAZ_OBEC"]}<br>`;

			if (pointInfo["NAZ_COB"]) {
				markup += `<strong>Časť obce:</strong> ${pointInfo["NAZ_COB"]}<br>`;
			}

			if (pointInfo["NAZ_KU"]) {
				markup += `<strong>Katastrálne územie:</strong> ${pointInfo["NAZ_KU"]}<br>`;
			} */
		}

		const corpora = JSON.parse(document.getElementById("appContainer").dataset.corpora);

		//PMa: example -> example_id. Robime tu s konkretnymy example_ids, nie s corpus_id. Takto tu vieme filtrovat kvizove ukazky 
		if (pointInfo["example_id"] && pointInfo["example_id"].length > 0) {
			markup += `<br>
            <h3>Kvíz</h3>
`;

			for (const exampleId of pointInfo["example_id"]) {
				//PMa: test ci example_id patri medzi kvizove ukazky
				if (quizManager.isExampleIdIncluded(exampleId)) {
					if (!quizManager.isFinished()) { //zobraz kvizovu otazku
					//const corpus = corpora[corpusId];
					const extra = {
						//corpusId: corpusId,
						exampleId: exampleId, 
						KOD_OBEC: pointInfo["KOD_OBEC"],
						KOD_COB: pointInfo["KOD_COB"],
					};

					markup += `
		<a href="#" style="display: block" class="link js-open-modal" data-extra='${JSON.stringify(extra)}' data-content-type="marker-card-ukazka" data-content-key="${dialectId}">
			<i class="fas fa-volume-up"></i> Kvízová otázka
		</a>
	`;
				}
				else { // quizManager.isFinished - zobraz vyhodnotenie pre tento bod
					const quizEvaluate = quizManager.getEvaluatedAnswer(exampleId);
					if (quizEvaluate) {
						markup += `
		<strong>Tvoja odpoveď:</strong><br>
		${quizEvaluate.answerDialectName}<br>
		<strong>Správna odpoveď:</strong><br>
		${quizEvaluate.correctAnswerDialectName}<br>
	`;
					}

				}
			}
			}
		}

		if (pointInfo["NAZ_OBEC"]) {
			markup += `<br>`;
		}

		return markup + `</div>`;
	}
}

export default new PointMarkupBuilder();
